module.exports = __webpack_public_path__ + "static/assets/0ab6ea64de18fd48012bb434e40e7983.svg";